document.addEventListener('DOMContentLoaded', function () {
  // Click event listener.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.classList.contains('axiosform')) {
      e.preventDefault();
      // Load context element.
      let context = document.getElementById(e.target.form.id);
      // Get url and form data.
      let url = e.target.form.action;
      let data = new FormData(e.target.form);
      // Set loader
      context.innerHTML = axiosModalLoader();
      // Call axios form.
      excludeUrl(url);
      axiosForm(context, url, data);
    }
  });
  // Execute all on page events.
  axiosInPage();
  // Listen to popstate events.
  window.onpopstate = function () {
    axiosCall('#main-page', document.location);
  }
});


$(document).ready(function () {
  $('.lds-container').fadeOut(250, function () {
    $('.lds-container').remove();
    $('#main-page').fadeIn(250);
  });
  $('body').on('click', '.axiospage', function (e) {
    e.preventDefault();

    let url = $(this).data('axiosroute');
    let replace = $(this).data('axiosreplace');

    axiosCall(replace, url);

    $('.nav-link').removeClass('active');
    $($(this).data('navtarget')).addClass('active');

    if ($('#sidebar').hasClass('show')) {
      $('#sidebar').removeClass('show');
      $('#sidebar').addClass('hidden');
    }
  });
  $('body').on('show.bs.modal', '.axiosmodal', function () {
    let url = $(this).data('axiosroute');
    let replace = $(this).data('axiosreplace');

    excludeUrl(url);
    axiosReplace(replace, url);
  });

});

/**
 * Generic axios call.
 *
 * @param  context
 * @param  url
 * @return void
 */
axiosReplace = function (context, url) {
  if ($(context).length) {
    axios.get(url).then(function (response) {
      $(context).fadeOut(250, function () {
        // Replace content with response.
        $(this).replaceWith(response.data);
        $(context).fadeIn(250);
        $(this).fadeIn(250);
      });
    });
  }
}

/**
 * Form axios call.
 *
 * @param  context
 * @param  url
 * @param  data
 * @param  timeout
 * @return void
 */
axiosForm = function (context, url, data, timeout = 250) {
  if (context.length) {
    axios.post(url, data).then(function (response) {
      fadeOut(context, timeout);

      setTimeout(function () {
        context.outerHTML = response.data;
        fadeIn(context, timeout);
      }, timeout);
    });
  }
}

/**
 * Run axios on page calls.
 *
 * @return void
 */
axiosInPage = function () {
  $('.axios').each(function (index, item) {
    let url = $(item).data('axiosroute');
    let replace = $(item).data('axiosreplace');

    excludeUrl(url);
    axiosReplace(replace, url);
  });
  $('.axios-chart').each(function (index, item) {
    let func = $(item).data('axioschart');
    window[func]();
  })
}

/**
 * Do an axios call.
 *
 * @param  context
 * @param  url
 * @return void
 */
axiosCall = function (context, url) {
  // Pushing the back button will return a Location object,
  // so we fetch the href from this object to use.
  if (url instanceof Location) {
    url = url.href;
  }
  // If the url is empty abort.
  if (!url) {
    return;
  }
  // Set timestamp.
  let ts = Date.now();
  // Set timestamp on <main>.
  $('main').data('ts', ts);
  // Show loader animation before each request.
  axios.interceptors.request.use(function (request) {
    // Abort if the url is excluded.
    if (excludedUrls.indexOf(request.url) === -1) {
      // Fade out and show loader.
      $(context).fadeOut(25, function () {
        $('body')[0].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        $(this).html(axiosLoader());
        $(this).fadeIn(50);
      });
    }
    return request;
  }, function (error) {
    return Promise.reject(error);
  });
  axios.get(url).then(function (response) {
    // The promise's timestamp (ts) should be equal or
    // greater than the container's timestamp (curTs).
    let curTs = $('main').data('ts');
    if (ts >= curTs) {
      // Update the history state if
      // the request is successfull.
      updateUrl(url);
      $(context).fadeOut(250, function () {
        // Check if <main> ts is not newer than promise ts.
        // Replace content with response.
        $(this).replaceWith(response.data);
        $(context).fadeIn(250);
        $(this).fadeIn(250);
        // Update the page title so
        // it corresponds to the
        // current page.
        updateTitle();
        // After replace, run in page calls.
        axiosInPage();
      });
    }
  }).catch(function (error) {
    // If the error is a 401 (unauthenticated),
    // reload the page to show the login form.
    if (error.response.status === 401) {
      window.location.reload(true); // Force refresh.
    } else {
      // Show an error popup if
      // the request is unsuccessfull.
      $(context).prepend(alertError(error.response.status)).fadeIn(250, function () {
        $('.popup-alert').delay(3000).fadeOut(1500, function () {
          $(this).remove();
        });
      });
    }
  });
}

/**
 * Add the current page to the browsers history.
 *
 * @param  url
 * @return void
 */
updateUrl = function (url) {
  history.pushState({id: url}, 'TotalWebBoost', url);
}

/**
 * Update the current page title.
 *
 * @return void
 */
updateTitle = function () {
  let title = document.getElementById('page-title').textContent;

  if (title) {
    document.title = title + ' - TotalWebBoost';
  }
}

/**
 * List of excluded urls.
 */
excludedUrls = [];

/**
 * Push an url to the excluded url's array.
 *
 * @return void
 */
excludeUrl = function (url) {
  if (excludedUrls.indexOf(url) === -1) {
    excludedUrls.push(url);
  }
}

/**
 * Lock company lead.
 *
 * @return void
 */
lockCompanyLead = function (url) {
  if (url) {
    axios.get(url).then(function () {
      setTimeout(function () {
        lockCompanyLead(url);
      }, 30000);
    });
  }
}

/**
 * Axios loader.
 *
 * @return string
 */
axiosLoader = function () {
  return '' +
    '<div class="lds-container">' +
    '<div class="lds-ring">' +
    '<div></div><div></div><div></div>' +
    '</div></div>';
}

/**
 * Axios modal loader.
 *
 * @return string
 */
axiosModalLoader = function () {
  return '' +
    '<div class="p-5">' +
    '<div class="my-5"><div>' +
    '<div class="lds-ring lds-ring-modal">' +
    '<div></div><div></div><div></div>' +
    '</div></div></div></div>';
}

/**
 * Show an alert for an HTTP status code.
 *
 * @param  code
 * @return string
 */
alertError = function (code) {
  let message;

  switch (code) {
    case 403:
      message = 'U heeft geen toegang tot deze pagina.';
      break;
    case 404:
      message = 'De opgevraagde pagina bestaat niet.';
      break;
    case 419:
      message = 'De door u ingevoerde url of token is verlopen.';
      break;
    case 429:
      message = 'Te veel verzoeken.';
      break;
    case 500:
      message = 'Interne serverfout.';
      break;
    case 503:
      message = 'Dienst niet beschikbaar. Probeer het later opnieuw.';
      break;
    default:
      message = 'Er is iets misgegaan. Probeer het opnieuw.';
      break;
  }

  return '<div class="popup-alert">'
    + '<div class="alert alert-danger text-center fade show" role="alert">'
    + '<strong>HTTP ' + code + '</strong>: ' + message
    + '</div>'
    + '</div>';
}
